import { useEffect, useState } from 'react';
import { contactApiKeyStore } from '../../../../api/contact-api-key-store';
import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { Contact } from '../../../../models/contact';
import { UserPermissionName } from '../../../../models/user-permission-name';
import { columns } from './customer-contacts-columns';
import useDebounce from '../../../../hooks/use-debounce';
import { useLoadData } from '../../../../hooks/useLoadData';
import { State } from '@progress/kendo-data-query';
import { ApiResponse } from '../../../../models/api-response';
import { GridColumnConfig, GridPreference } from '../../../../models/gridCoumnConfig';
import { gridApiKeyStore } from '../../../../api/grid-api-key-store';
import { useSaveData } from '../../../../hooks/useSaveData';

interface ProjectsTabProps {
  customerID: number;
}
export const CustomerDetailsTab = ({ customerID }: ProjectsTabProps) => {
  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout,
  } = useLoadData<ApiResponse<GridPreference>>(gridApiKeyStore.getGridLayout('Customer Details', 'Contacts'));

  const {
    isLoading: isLoadingFile,
    data: contacts,
    refetch,
  } = useLoadData<ApiResponse<Contact[]>>(contactApiKeyStore.getCustomerContacts(customerID));

  const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();

  const [filteredContacts, setFilteredContacts] = useState<Contact[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredContactList = contacts?.data?.filter((file) =>
      Object.values(file).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredContacts(filteredContactList || []);
  }, [debouncedSearchTerm, contacts?.data]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'Contacts',
      pageName: 'Customer Details',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'Contacts',
      pageName: 'Customer Details',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      // if (filterData && columnJson) {
      setGridConfig({
        columns: columnJson,
        dataState: filterData,
      });
      // }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);
  return (
    <SiTrackGrid
    fileTitle='customer_contract'
      columns={columns}
      dataItemKey="contactsID"
      // queryConfig={contactApiKeyStore.getCustomerContacts(customerID)}
      actionPermissions={{
        export: UserPermissionName.DOWNLOAD_GRID,
      }}
      // -----------------Grid Layout-------
      dataItems={filteredContacts || []}
      reorderable
      handleSearch={handleInputChange}
      handleSaveLayout={handleSaveLayout}
      isSaveLayout={true}
      gridConfigFromApi={gridConfig}
      handleResetLayout={handleResetLayout}
      // -----------------Grid Layout-------
    />
  );
};
